import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IFileData } from '@services/file-transfer';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AbstractControl, FormControl } from '@angular/forms';
import { UploadFileResp } from '@interfaces';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements OnInit {
  @Input() fControl: FormControl | AbstractControl;
  @Input() uploadReq: (file: IFileData) => Observable<UploadFileResp>;
  @Input() path: string;

  acts = {
    isLoading: false,
  };

  tempData = {
    file: null,
  };

  @Output() emitUploadEnd = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  onGetFileData(fileData: IFileData) {
    this.tempData.file = fileData.file?.url;
    this.acts.isLoading = true;
    this.uploadReq(fileData)
      .pipe(finalize(() => (this.acts.isLoading = false)))
      .subscribe((res) => this.fControl.setValue(`${this.path}/${res.path}`));
  }

  removeMedia() {
    this.tempData.file = null;
    this.fControl.setValue(null);
  }

  get uploadBtnTitle() {
    if (this.acts.isLoading) return 'uploading...';
    return this.fControl.value ? 'replace' : 'upload';
  }
}
